import { split, toString } from 'lodash';

const SHOPIFY_GID_PREFIX = `gid://shopify`;

class StorefrontUtil {
  static convertGidtoId = gid => {
    const [...segments] = split(gid, '/');
    const rawId = segments[segments.length - 1];
    const id = split(rawId, '?')[0];

    return id;
  };

  static convertToGid = ({ id, resourceType }) => {
    if (!id) {
      return { id, resourceType };
    }
    if (toString(id).match(SHOPIFY_GID_PREFIX)) return id;

    const gid = `${SHOPIFY_GID_PREFIX}/${resourceType}/${id}`;

    return gid;
  };
}

export default StorefrontUtil;
